const SALT = "SQsktmfXKWUtJaSukTa3"
const TOKEN_SECRET = "MFJWxXGbsUKRaKQ5YPpj"

export function moduleDefault<T>(mod: (T & { default?: T }) | null | undefined): T {
    try {
        if (mod && typeof mod === 'object' && 'default' in mod && mod.default) return mod.default
    } catch {
        return mod as T
    }
    return mod as T
}

const jwtAndEncrypt = async (wallet: any, token: any) => {
    // jsonwebtoken and crypto-js stay off the shared chunk. Push-token
    // registration is the only caller, and it already runs after a click.
    const [jwtMod, cryptoMod] = await Promise.all([import('jsonwebtoken'), import('crypto-js')])
    const jwt = moduleDefault(jwtMod)
    const CryptoJS = moduleDefault(cryptoMod)
    const sign = jwt.sign
    var jwtToken = sign({
    // expires in 60 seconds
    exp: Math.floor(Date.now() / 1000) + (60),
    token: token,
    wallet_address: wallet
    }, TOKEN_SECRET);

    // Generate random 16 bytes to use as IV
    var IV = CryptoJS.lib.WordArray.random(16);

    // finds the SHA-256 hash for the SALT
    var Key = CryptoJS.SHA256(SALT);
    var val = CryptoJS.enc.Utf8.parse(jwtToken);
    var encrypted = CryptoJS.AES.encrypt(val, Key, { iv: IV }).toString();
    var b64 = CryptoJS.enc.Base64.parse(encrypted).toString(CryptoJS.enc.Hex);

    return {
        data: b64,
        iv: IV.toString()
    }
}

export default jwtAndEncrypt
